import React from 'react';
import { Link } from 'react-router-dom';
import dateHelper from '../../util/dateFormatter'
import CategoryListLink from './CategoryListLink';
import ProductListLink from './ProductListLink';
const MerchantList = props => {
    if (!props.merchants) {
        return (
            <div className='broad'>Loading...</div>
        )
    }

    if (props.merchants.length === 0) {
        return (
            <div className='empty'>
                No merchants...
      </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>id</th>
                        <th>name</th>
                        <th>email</th>
                        <th>categories</th>
                        <th>products</th>
                        <th>created</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.merchants.map(item => {
                            return (
                                <tr key={item.email}>
                                    <td className="keyfield"><Link to={`/users/${item.key}`}>{item.key}</Link></td>
                                    <td>{item.firstname} {item.lastname}</td>
                                    <td>{item.email}</td>
                                    <td className="keyfield"><CategoryListLink userKey={item.key} currentUser={props.currentUser} /></td>
                                    <td className="keyfield"><ProductListLink userKey={item.key} currentUser={props.currentUser} /></td>
                                    <td>{dateHelper.Formatter.toLocalString(item.created)}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default MerchantList;



// WEBPACK FOOTER //
// ./src/components/widgets/MerchantList.js